import { render, staticRenderFns } from "./CertificateManager.vue?vue&type=template&id=1292e224&"
import script from "./CertificateManager.vue?vue&type=script&lang=js&"
export * from "./CertificateManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports